import { CustomExportFileModel } from "./customExportFile.model";

export class InvoiceCustomerFilter{
    phoneNumber:string;
    customerName:string;
    shipmentNumberS:string;
    customerId:number;
    fromDate:any;
    toDate:any;
    invNo:string;
    name:string;
    companyName:string;
    invoiceStatusId:number;
    invoiceCustomerTypeId:number;
    signingDateFrom:any;
    signingDateTo:any;
    pageNumber:number=1;
    pageSize:number=20;
    customExportFile: CustomExportFileModel = new CustomExportFileModel();
}